import { render } from "./DynamicSidebar.vue?vue&type=template&id=2bb7d0d4"
import script from "./DynamicSidebar.vue?vue&type=script&lang=js"
export * from "./DynamicSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__